import React, { memo } from 'react';
import styles from './blog.module.css';
import Post from '../item';
import { getDate } from '../helpers';

interface Props {
  list: ReadonlyArray<any>;
  pathname: string;
}

function PostList({ list, pathname }: Props) {
  const sortedList = [...list].sort((a, b) => +new Date(b.date) - +new Date(a.date));

  return (
    <ul className={styles.list}>
      {sortedList.map((e) => (
        <li key={e.id} className={styles.item}>
          <Post
            img={e.main_photo?.childImageSharp.fluid}
            date={getDate(e.date)}
            path={pathname}
            {...e}
          />
        </li>
      ))}
    </ul>
  );
}

export default memo(PostList);
